import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f4cc7a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "multiple-view-content" }
const _hoisted_2 = {
  key: 0,
  class: "multiple-view-line"
}
const _hoisted_3 = {
  key: 1,
  class: "multiple-edit-line"
}
const _hoisted_4 = {
  key: 1,
  style: {"margin-top":"8px"}
}
const _hoisted_5 = { style: {"margin-left":"-16px","margin-right":"-16px"} }


const __default__ = { name: 'MultipleItem' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  view: Boolean,
  line: {
    type: Boolean,
    default: true
  },
  span: {
    type: Number,
    default: 24
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_col = _resolveComponent("a-col")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.line)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (__props.view)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2))
            : (_openBlock(), _createElementBlock("div", _hoisted_3))
        ], 64))
      : (_openBlock(), _createElementBlock("p", _hoisted_4)),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_a_col, {
        span: 24,
        class: _normalizeClass({ 'multiple-view': __props.view })
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { gutter: 46 }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["class"])
    ])
  ]))
}
}

})